import axios from "../axios";

/**
 * 材料推优保存
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const save = (data) => {
  return axios({
    url: "/mCltyRecord/save",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}
/**
 * 根据id获取信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const getCltyInfoById = (data) => {
  return axios({
    url: "/mCltyRecord/view",
    method: 'post',
    data
  })
}
/**
 * 列表查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const getList = (data) => {
  return axios({
    url: '/mCltyRecord/list',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}
/**
 * 材料产品推优申报驳回
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const rejectClcptysb = (data) => {
  return axios({
    url: "/mCltyRecord/rejectClcptysb",
    method: 'post',
    data
  })
}
/**
 * 材料产品审核通过
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const approveClcptysb = (data) => {
  return axios({
    url: "/mCltyRecord/approveClcptysb",
    method: 'post',
    data
  })
}
/**
 * 获取评审列表
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const getPsList = (data) => {
  return axios({
    url: "/mCltyRecord/getPsList",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 材料推优评审保存
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const saveCltyPs = (data) => {
  return axios({
    url: "/mCltyRecord/saveCltyPs",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const getCltyReviewInfoById = (data) => {
  return axios({
    url: "/mCltyRecord/getCltyReviewInfoById",
    method: 'post',
    data
  })
}

export const download=(data)=>{
  return axios({
    url: '/mCltyRecord/download',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}

let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}

export const clcptysbExcel=(name,data)=>{
  return axios({
    url: "/mCltyRecord/clcptysbExcel",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res=>{
    if (res){
      openDownloadDialog(res,name)
    }
  })
}

export const  clcptypsExcel=(name,data)=>{
  return axios({
    url: "/mCltyRecord/clcptypsExcel",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res=>{
    if (res){
      openDownloadDialog(res,name)
    }
  })
}
export const getSbtjbList = (data) => {
  return axios({
    url: '/mCltyRecord/getSbtjbList',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

export const downloadClWord=(data)=>{
  return axios({
    url: '/mCltyRecord/downloadClWord',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/clty.js